import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-zstack",
  "use": "oc-zstack-usage",
  "viewBox": "0 0 1170 1024",
  "content": "<symbol viewBox=\"0 0 1170 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"oc-zstack\"><path d=\"M605.696 0.731429H513.462857L394.24 200.923429h82.212571L7.387429 998.034286h314.368l114.834285-200.557715H355.035429L712.411429 200.923429z\" fill=\"#01529A\" /><path d=\"M754.102857 258.56l-277.942857 471.844571h307.273143l38.765714 67.072H519.533714l-108.032 200.557715h755.858286L948.297143 599.771429h-158.793143l32.621714-70.729143h82.358857z\" fill=\"#87AAD9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol